import { useState, useEffect } from 'react'
import { Menu, X } from 'lucide-react'
import type { NavigationItem } from './AppShell'

export interface MainNavProps {
  items: NavigationItem[]
  onNavigate?: (href: string) => void
}

export function MainNav({ items, onNavigate }: MainNavProps) {
  const [isOpen, setIsOpen] = useState(false)

  // Close menu on escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setIsOpen(false)
    }

    if (isOpen) {
      document.addEventListener('keydown', handleEscape)
      // Prevent body scroll when menu is open
      document.body.style.overflow = 'hidden'
    }

    return () => {
      document.removeEventListener('keydown', handleEscape)
      document.body.style.overflow = 'unset'
    }
  }, [isOpen])

  const handleNavigate = (href: string) => {
    onNavigate?.(href)
    setIsOpen(false)
  }

  return (
    <>
      {/* Hamburger Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="p-2 transition-colors rounded-lg hover:bg-slate-800"
        aria-label="Toggle navigation menu"
      >
        {isOpen ? (
          <X className="w-6 h-6 text-slate-300" />
        ) : (
          <Menu className="w-6 h-6 text-slate-300" />
        )}
      </button>

      {/* Backdrop */}
      {isOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/60"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Slide-in Menu */}
      <nav
        className={`
          fixed top-16 right-0 bottom-0 w-72 bg-slate-900 border-l border-slate-800 z-50
          transform transition-transform duration-300 ease-in-out
          ${isOpen ? 'translate-x-0' : 'translate-x-full'}
        `}
      >
        <div className="p-6">
     

          <ul className="space-y-2">
            {items.map((item) => (
              <li key={item.href}>
                <button
                  onClick={() => handleNavigate(item.href)}
                  className={`
                    w-full text-left px-4 py-3 rounded-lg font-medium transition-colors
                    ${
                      item.isActive
                        ? 'bg-amber-500/10 text-amber-500 border border-amber-500/20'
                        : 'text-slate-300 hover:bg-slate-800 hover:text-amber-500'
                    }
                  `}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>

          {/* Mobile Submit Button */}
          <div className="mt-8 sm:hidden">
            <button
              onClick={() => {
                handleNavigate('/submit')
              }}
              className="w-full px-4 py-3 font-semibold transition-colors rounded-lg bg-amber-500 hover:bg-amber-600 text-slate-900"
            >
              ضيف كلمة جديدة
            </button>
          </div>
        </div>
      </nav>
    </>
  )
}
